import React from 'react';
import { Target, Users, Shield, Clock } from 'lucide-react';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: Target,
      title: 'Domain Expertise',
      description: 'Our professionals have extensive experience working with CMBS/CRE lenders, brokers, and third-party due-diligence companies, providing deep industry knowledge.'
    },
    {
      icon: Users,
      title: 'Dedicated Teams',
      description: 'We become an extension of your team, providing dedicated resources that understand your processes and deliver consistent quality.'
    },
    {
      icon: Shield,
      title: 'Quality Assurance',
      description: 'Multiple quality checkpoints and experienced reviewers ensure 99%+ accuracy on all deliverables.'
    },
    {
      icon: Clock,
      title: 'Scalable Capacity',
      description: 'Flexible resource allocation allows us to scale up or down based on your deal flow and project requirements.'
    }
  ];

  return (
    <section className="relative py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-[#005B63]/10 rounded-full text-[#005B63] text-sm font-medium mb-4">
            Why Choose Us
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            The Integrand Advantage
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We deliver premium quality services that help our clients realize outsourced cost advantages without compromising on quality.
          </p>
        </div>

        {/* Reasons grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-xl p-6 hover:border-[#005B63]/50 hover:shadow-lg transition-all duration-300 group"
            >
              <div className="w-12 h-12 bg-[#005B63]/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#005B63] transition-colors">
                <reason.icon className="w-6 h-6 text-[#005B63] group-hover:text-white transition-colors" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-[#005B63] transition-colors">
                {reason.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
